import { VersicherungsangabenSectionConfig } from '@/features/Versicherungsangaben/types';
import { SECTION } from '@/components/layout/types';
import { ROLE } from '@/features/Clients/types';
import { useClientStore } from '@/features/Clients/store';
import { computed } from 'vue';

const sectionLabel = computed(() => {
  if (
    useClientStore().isSameByRole(
      ROLE.VERSICHERUNGSNEHMER,
      ROLE.VERSICHERTE_PERSON,
    )
  ) {
    return 'Angaben zu Versicherungsnehmer / versicherter Person';
  }
  return 'Angaben zum Versicherungsnehmer';
});

export const contractVersicherungsangabenSectionConfig: VersicherungsangabenSectionConfig =
  {
    [SECTION.CONTRACT_CLIENT_VP]: {
      label: 'Angaben zur versicherten Person',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
        ),
      componentProps: {
        role: 'versichertePerson',
        label: 'Angaben zur versicherten Person',
      },
    },
    [SECTION.CONTRACT_CLIENT]: {
      label: sectionLabel,
      component: () =>
        import(
          '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
        ),
      componentProps: {
        label: sectionLabel,
      },
    },
  };
